/**
 * Company section: ピン留め + 内部スクロール
 *
 * - section.height = 180vh、内部に position:sticky の __pin (100vh)
 * - section.top <= 0 で .is-pinned 付与 → オーバーレイはCSSのtransitionで自動フェード
 * - 中身は scroll 進行度に応じて translateY(100%) → 0 にスライド
 */
export const initCompanyScroll = () => {
  const section = document.querySelector('.front-company');
  if (!section) return;

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  let raf = 0;
  const update = () => {
    if (isMobile()) {
      section.classList.remove('is-pinned');
      section.style.removeProperty('--content-translate');
      return;
    }

    const rect = section.getBoundingClientRect();
    const sectionH = section.offsetHeight;
    const vh = window.innerHeight;
    const pinLength = sectionH - vh;

    const scrolled = -rect.top;
    const progress = Math.max(0, Math.min(1, scrolled / pinLength));

    // pin 状態：一度 top が画面上端を超えたら、bottom が画面外に消えるまで維持
    section.classList.toggle('is-pinned', rect.top <= 0 && rect.bottom > 0);

    // 中身のスライド：進行度 0→1 で translateY 100%→0
    const translatePct = (1 - progress) * 100;
    section.style.setProperty('--content-translate', String(translatePct));
  };

  window.addEventListener(
    'scroll',
    () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    },
    { passive: true }
  );
  window.addEventListener('resize', update);
  update();
};
